<template>
	<Col>
		<Row class="flex-justify-space-between flex-align-center pt-7 pr-6">
			<Col>
				<h1 class="title-text">Task log</h1>
				<h3 class="description-text">Analyze logs of previous feature runs</h3>
			</Col>
		</Row>
		<div class="display-flex flex-stretch-to-scroll height-100 task-log">
			<TaskLogList :workflowId="workflowId" :errorMessage="errorMessage" :searchDisabled="searchDisabled" class="page-left-side" />
			<div class="vertical-divider" />

			<div v-if="hasSubRoute" class="page-right-side flex-stretch-to-scroll">
				<div class="height-100">
					<router-view></router-view>
				</div>
			</div>
			<div v-else class="flex-center-100 page-placeholder-message">Select a log entry</div>
		</div>
	</Col>
</template>

<script>
import TaskLogList from '@/components/TaskLog/TaskLogList';

const CMP_NAME = 'TaskLog';

export default {
	name: CMP_NAME,
	props: {
		workflowId: { type: Number, required: false },
		errorMessage: { type: String, required: false },
		searchDisabled: { type: Boolean, default: false },
	},
	components: {
		TaskLogList,
	},
	computed: {
		hasSubRoute() {
			return this.$route.name !== CMP_NAME;
		},
	},
};
</script>

<style scoped lang="scss">
.task-log {
	// Todo: 'page-left-side' and 'page-right-side' should probably be extracted to an outside new layout
	.page-left-side {
		height: 100%;
		max-width: 485px;
		min-width: 440px;
		background: rgb(255, 255, 255);
	}

	.vertical-divider {
		margin: 0 2%;
	}

	.page-right-side {
		flex: 1;
		height: 100%;
		padding: 8px 0;
	}
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
	text-align: left;
	letter-spacing: 0px;
}
</style>
